import styled from "styled-components";
import { StyleableSvgImage as StyleableSvgImageBase } from "@ubnt/store.core/lib/components/StyleableSvgImage";
import { BREAKPOINTS } from "layout";

export const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 18px;
  margin-top: 32px;
`;

export const Card = styled.div`
  border-radius: 4px;
  background: #f9f9fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 280px;
  height: 305px;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    width: 100%;
  }
`;

export const StyleableSvgImage = styled(StyleableSvgImageBase)`
  color: #006fff;
`;

export const Title = styled.span`
  color: #3b3f45;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-top: 12px;
`;

export const LinkContainer = styled.a`
  display: flex;
  align-items: center;
  color: #006fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
  margin-top: 5px;
  text-decoration: none;
  gap: 4px;

  &:hover {
    color: #006fff;
  }
`;
